import { useState } from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import { useApplyCouponToTenantMutation } from '../hooks/useDiscountCouponQuery'

function buildErrorMessage(error) {
  const data = error?.response?.data

  if (data?.codeError) {
    return data.message && data.message.trim() !== '' ? data.message : `Erro ao aplicar cupom (${data.codeError})`
  }

  return data?.errorMessage || error?.message || 'Erro desconhecido'
}

function TenantCouponTab() {
  const applyMutation = useApplyCouponToTenantMutation()

  const [tenantId, setTenantId] = useState('')
  const [couponCode, setCouponCode] = useState('')
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' })

  function notify(message, severity = 'info') {
    setSnackbar({ open: true, message, severity })
  }

  function handleSnackbarClose() {
    setSnackbar((current) => ({ ...current, open: false }))
  }

  function handleApply() {
    applyMutation.mutate(
      { tenantId, couponCode },
      {
        onSuccess: () => {
          notify(`Cupom ${couponCode} aplicado ao tenant ${tenantId} com sucesso`, 'success')
          setTenantId('')
          setCouponCode('')
        },
        onError: (error) => notify(buildErrorMessage(error), 'error'),
      },
    )
  }

  const isValid = tenantId.trim() !== '' && couponCode.trim() !== ''

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 3 }}>
        Aplica um cupom de desconto já cadastrado diretamente no plano atual do tenant. A validação verifica
        compatibilidade de plano/periodicidade/perfil, mas não checa exclusividade do cupom nem valor mínimo de
        upgrade (diferente do fluxo normal de contratação).
      </Alert>

      <Paper sx={{ p: 3 }} variant="outlined">
        <Stack spacing={2}>
          <TextField
            id="tenant-id"
            label="Tenant (contrato)"
            placeholder="ex: 1234567890123456"
            value={tenantId}
            onChange={(event) => setTenantId(event.target.value)}
            fullWidth
          />
          <TextField
            id="tenant-coupon-code"
            label="Código do cupom existente"
            placeholder="ex: BEMVINDO20"
            value={couponCode}
            onChange={(event) => setCouponCode(event.target.value)}
            fullWidth
          />
          <Box>
            <Button
              variant="contained"
              onClick={handleApply}
              disabled={!isValid || applyMutation.isPending}
            >
              Associar ao tenant
            </Button>
          </Box>
        </Stack>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default TenantCouponTab
